// @ts-strict-ignore
import {Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from "@angular/core";
import {EventEmitterService} from "@event-emitter";
import {SimUtilityExtendedService} from "@services";
import {DynamicScriptDirective} from "../../../../../custom-directives/dynamic-script.directive";
import {Media} from "@models";

//not available on NPM/too old
declare var odf: any;

@Component({
	selector: "sim-odp-viewer",
	templateUrl: "./odp-viewer.component.html",
	styleUrls: ["./odp-viewer.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class OdpViewerComponent implements OnInit, OnChanges, OnDestroy {
	@Input() media: Media = null;
	public odfCanvasInstance: any = null;
	public odf: any = null;
	public root: any = null;
	private pageRendering = false;
	private pageNumPending: number = null;
	private pages: Array<any> = null;
	private pageNum = 1;
	private pageScale = 1.5;

	private loadSkipped = false;
	@ViewChild("webodfjs", {static: true}) webodfScript: DynamicScriptDirective;
	@ViewChild("canvasContainer", {static: true})
	canvasContainer: ElementRef<HTMLDivElement>;
	@ViewChild("odfCanvas", {static: true})
	odfCanvas: ElementRef<HTMLDivElement>;

	constructor(
		private _simUtilityService: SimUtilityExtendedService,
		private _emitterService: EventEmitterService,
	) {}

	ngOnInit() {
		this.webodfScript.onResult.then(() => {
			this.odfCanvasInstance = new odf.OdfCanvas(this.odfCanvas.nativeElement);
			if (this.loadSkipped) {
				this.loadOdf();
			}
		});

		// this._emitterService.onPresentationBackward.subscribe((args) => {
		// 	if (this.media.mediaId === args.mediaId) {
		// 		if (args.fast) {
		// 			this.firstPage();
		// 		} else {
		// 			this.prevPage();
		// 		}
		// 	}
		// });
		//
		// this._emitterService.onPresentationForward.subscribe((args) => {
		// 	if (this.media.mediaId === args.mediaId) {
		// 		if (args.fast) {
		// 			this.lastPage();
		// 		} else {
		// 			this.nextPage();
		// 		}
		// 	}
		// });
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes["media"]) {
			if (this.odfCanvasInstance) {
				this.loadOdf();
			} else {
				this.loadSkipped = true;
			}
		}
	}

	public ngOnDestroy(): void {}

	private firstPage() {
		this.pageNum = 1;
		this.queueRenderPage(this.pageNum);
	}

	private lastPage() {
		this.pageNum = this.pages.length;
		this.queueRenderPage(this.pageNum);
	}

	private prevPage() {
		if (this.pageNum > 1) {
			this.pageNum--;
			this.queueRenderPage(this.pageNum);
		}
	}

	private nextPage() {
		if (this.pageNum < this.pages.length) {
			this.pageNum++;
			this.queueRenderPage(this.pageNum);
		}
	}

	private loadOdf() {
		setTimeout(() => {
			if (this.odfCanvasInstance && this.media) {
				const odfUrl = this._simUtilityService.getMediaPath(this.media);

				this.pageRendering = true;

				this.odfCanvasInstance.load(odfUrl);

				this.odfCanvasInstance.addListener("statereadychange", () => {
					this.root = this.odfCanvasInstance.odfContainer().rootElement;

					this.pageRendering = false;

					this.pages = this.getPages();

					this.showPage(1);
				});
			} else {
				console.error("ODF Plugin not initialized correctly.");
			}
		});
	}

	private queueRenderPage(num: number) {
		if (this.pageRendering) {
			this.pageNumPending = num;
		} else {
			this.showPage(num);
		}
	}

	private nsResolver(prefix) {
		let ns = {
			draw: "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			presentation: "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
			text: "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			office: "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
		};

		return ns[prefix] || console.log("prefix [" + prefix + "] unknown.");
	}

	private getPages() {
		let pageNodes = Array.prototype.slice.call(this.root.getElementsByTagNameNS(this.nsResolver("draw"), "page")),
			pages = [],
			i,
			tuple;

		for (i = 0; i < pageNodes.length; i += 1) {
			tuple = [pageNodes[i].getAttribute("draw:name"), pageNodes[i]];
			pages.push(tuple);
		}
		return pages;
	}

	private showPage(n) {
		if (this.odfCanvasInstance) {
			this.pageRendering = true;

			if (n <= 0) {
				n = 1;
			} else if (n > this.pages.length) {
				n = this.pages.length;
			}

			this.odfCanvasInstance.showPage(n);

			this.pageRendering = false;

			this.pageNum = n;
		}
	}
}
